import * as queries from "./query";
import * as mutations from "./mutation";

import RootService from "@services";

export default new RootService({ queries, mutations });
